{
    "v": "5.3.4",
    "fr": 29.9700012207031,
    "ip": 0,
    "op": 51.0000020772726,
    "w": 600,
    "h": 600,
    "nm": "Comp 1",
    "ddd": 0,
    "assets": [],
    "layers": [
        {
            "ddd": 0,
            "ind": 1,
            "ty": 4,
            "nm": "Full Hand Outlines",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 11
                },
                "r": {
                    "a": 1,
                    "k": [
                        {
                            "i": {
                                "x": [
                                    0.667
                                ],
                                "y": [
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.333
                                ],
                                "y": [
                                    0
                                ]
                            },
                            "n": [
                                "0p667_1_0p333_0"
                            ],
                            "t": 0,
                            "s": [
                                11
                            ],
                            "e": [
                                -5
                            ]
                        },
                        {
                            "t": 38.0000015477717
                        }
                    ],
                    "ix": 10
                },
                "p": {
                    "a": 1,
                    "k": [
                        {
                            "i": {
                                "x": 0.667,
                                "y": 1
                            },
                            "o": {
                                "x": 0.333,
                                "y": 0
                            },
                            "n": "0p667_1_0p333_0",
                            "t": 0,
                            "s": [
                                478,
                                350,
                                0
                            ],
                            "e": [
                                231,
                                350,
                                0
                            ],
                            "to": [
                                -41.1666679382324,
                                0,
                                0
                            ],
                            "ti": [
                                41.1666679382324,
                                0,
                                0
                            ]
                        },
                        {
                            "t": 30.0000012219251
                        }
                    ],
                    "ix": 2
                },
                "a": {
                    "a": 0,
                    "k": [
                        968,
                        563,
                        0
                    ],
                    "ix": 1
                },
                "s": {
                    "a": 0,
                    "k": [
                        100,
                        100,
                        100
                    ],
                    "ix": 6
                }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [
                                            0,
                                            -4.301
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0.5,
                                            -0.199
                                        ],
                                        [
                                            0.399,
                                            0.301
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            3.101,
                                            -2.102
                                        ],
                                        [
                                            0.3,
                                            -2.102
                                        ],
                                        [
                                            -1.399,
                                            -1.705
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -8.601,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -4.698,
                                            4.796
                                        ],
                                        [
                                            0,
                                            6.7
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            4.204,
                                            0
                                        ],
                                        [
                                            1.398,
                                            -2.202
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            4.301,
                                            0
                                        ],
                                        [
                                            1.398,
                                            -2.203
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            4.301,
                                            0
                                        ],
                                        [
                                            1.399,
                                            -2.203
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            1.398,
                                            1.398
                                        ],
                                        [
                                            2,
                                            0
                                        ]
                                    ],
                                    "o": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0.399
                                        ],
                                        [
                                            -0.399,
                                            0.2
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -2.601,
                                            -2.601
                                        ],
                                        [
                                            -1.801,
                                            1.2
                                        ],
                                        [
                                            -0.301,
                                            2.2
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            5.5,
                                            6.601
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            6.699,
                                            0
                                        ],
                                        [
                                            4.802,
                                            -4.802
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            -4.199
                                        ],
                                        [
                                            -2.699,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            -4.199
                                        ],
                                        [
                                            -2.699,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            -4.2
                                        ],
                                        [
                                            -2.7,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            -2
                                        ],
                                        [
                                            -1.399,
                                            -1.399
                                        ],
                                        [
                                            -4.199,
                                            0
                                        ]
                                    ],
                                    "v": [
                                        [
                                            -17.348,
                                            -39.751
                                        ],
                                        [
                                            -17.348,
                                            10.349
                                        ],
                                        [
                                            -18.047,
                                            11.349
                                        ],
                                        [
                                            -19.247,
                                            11.151
                                        ],
                                        [
                                            -26.95,
                                            3.247
                                        ],
                                        [
                                            -36.75,
                                            2.349
                                        ],
                                        [
                                            -40.051,
                                            7.651
                                        ],
                                        [
                                            -38.352,
                                            13.754
                                        ],
                                        [
                                            -19.051,
                                            37.054
                                        ],
                                        [
                                            3.05,
                                            47.452
                                        ],
                                        [
                                            15.051,
                                            47.452
                                        ],
                                        [
                                            32.852,
                                            40.054
                                        ],
                                        [
                                            40.25,
                                            22.252
                                        ],
                                        [
                                            40.352,
                                            -1.655
                                        ],
                                        [
                                            32.749,
                                            -9.256
                                        ],
                                        [
                                            26.249,
                                            -5.655
                                        ],
                                        [
                                            26.249,
                                            -5.854
                                        ],
                                        [
                                            18.549,
                                            -13.553
                                        ],
                                        [
                                            12.05,
                                            -9.951
                                        ],
                                        [
                                            12.05,
                                            -10.151
                                        ],
                                        [
                                            4.352,
                                            -17.85
                                        ],
                                        [
                                            -2.148,
                                            -14.248
                                        ],
                                        [
                                            -2.148,
                                            -39.853
                                        ],
                                        [
                                            -4.348,
                                            -45.251
                                        ],
                                        [
                                            -9.747,
                                            -47.451
                                        ]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": {
                                "a": 0,
                                "k": [
                                    0.933,
                                    0.925,
                                    0.949,
                                    1
                                ],
                                "ix": 4
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 5
                            },
                            "r": 1,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    959.127,
                                    546.021
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 1",
                    "np": 2,
                    "cix": 2,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "o": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "v": [
                                        [
                                            -19.634,
                                            -20.217
                                        ],
                                        [
                                            24.137,
                                            -14.842
                                        ],
                                        [
                                            19.637,
                                            21.817
                                        ],
                                        [
                                            -24.135,
                                            16.442
                                        ]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ind": 1,
                            "ty": "sh",
                            "ix": 2,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [
                                            1.064,
                                            -8.708
                                        ],
                                        [
                                            -1.112,
                                            -2.737
                                        ],
                                        [
                                            -0.915,
                                            -0.113
                                        ],
                                        [
                                            -0.419,
                                            0.053
                                        ],
                                        [
                                            0.563,
                                            1.316
                                        ],
                                        [
                                            -0.25,
                                            2.049
                                        ],
                                        [
                                            -6.528,
                                            -0.806
                                        ],
                                        [
                                            0.801,
                                            -6.56
                                        ],
                                        [
                                            0.316,
                                            -0.896
                                        ],
                                        [
                                            -1.505,
                                            -0.393
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            -0.469,
                                            1.295
                                        ],
                                        [
                                            -0.151,
                                            1.229
                                        ],
                                        [
                                            9.477,
                                            1.17
                                        ],
                                        [
                                            0.71,
                                            0
                                        ]
                                    ],
                                    "o": [
                                        [
                                            -0.363,
                                            2.969
                                        ],
                                        [
                                            0.41,
                                            0.883
                                        ],
                                        [
                                            0.51,
                                            0.063
                                        ],
                                        [
                                            1.309,
                                            -0.567
                                        ],
                                        [
                                            -0.806,
                                            -1.867
                                        ],
                                        [
                                            0.801,
                                            -6.555
                                        ],
                                        [
                                            6.522,
                                            0.804
                                        ],
                                        [
                                            -0.1,
                                            0.821
                                        ],
                                        [
                                            -0.684,
                                            1.369
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            1.289,
                                            0.472
                                        ],
                                        [
                                            0.353,
                                            -1.203
                                        ],
                                        [
                                            1.255,
                                            -9.416
                                        ],
                                        [
                                            -0.726,
                                            -0.089
                                        ],
                                        [
                                            -8.565,
                                            -0.001
                                        ]
                                    ],
                                    "v": [
                                        [
                                            -17.367,
                                            2.353
                                        ],
                                        [
                                            -16.152,
                                            11.03
                                        ],
                                        [
                                            -14.073,
                                            12.639
                                        ],
                                        [
                                            -12.812,
                                            12.483
                                        ],
                                        [
                                            -11.368,
                                            9.126
                                        ],
                                        [
                                            -12.185,
                                            3.098
                                        ],
                                        [
                                            1.096,
                                            -7.329
                                        ],
                                        [
                                            11.47,
                                            6.017
                                        ],
                                        [
                                            10.966,
                                            8.45
                                        ],
                                        [
                                            12.436,
                                            11.645
                                        ],
                                        [
                                            12.435,
                                            11.645
                                        ],
                                        [
                                            15.744,
                                            9.973
                                        ],
                                        [
                                            16.476,
                                            6.53
                                        ],
                                        [
                                            1.635,
                                            -12.569
                                        ],
                                        [
                                            -0.522,
                                            -12.702
                                        ]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 2",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "mm",
                            "mm": 4,
                            "nm": "Merge Paths 1",
                            "mn": "ADBE Vector Filter - Merge",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": {
                                "a": 0,
                                "k": [
                                    1,
                                    1,
                                    1,
                                    1
                                ],
                                "ix": 4
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 5
                            },
                            "r": 1,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": true
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    949.766,
                                    500.702
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 2",
                    "np": 4,
                    "cix": 2,
                    "ix": 2,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 150.000006109625,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 2,
            "ty": 4,
            "nm": "Shape Layer 2",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 1,
                    "k": [
                        {
                            "i": {
                                "x": [
                                    0.667
                                ],
                                "y": [
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.333
                                ],
                                "y": [
                                    0
                                ]
                            },
                            "n": [
                                "0p667_1_0p333_0"
                            ],
                            "t": 18,
                            "s": [
                                100
                            ],
                            "e": [
                                1
                            ]
                        },
                        {
                            "t": 30.0000012219251
                        }
                    ],
                    "ix": 11
                },
                "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 10
                },
                "p": {
                    "a": 0,
                    "k": [
                        162,
                        320,
                        0
                    ],
                    "ix": 2
                },
                "a": {
                    "a": 0,
                    "k": [
                        0,
                        0,
                        0
                    ],
                    "ix": 1
                },
                "s": {
                    "a": 0,
                    "k": [
                        100,
                        100,
                        100
                    ],
                    "ix": 6
                }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "o": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "v": [
                                        [
                                            -116.872,
                                            -34.976
                                        ],
                                        [
                                            318.199,
                                            -34.976
                                        ]
                                    ],
                                    "c": false
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "tm",
                            "s": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": {
                                            "x": [
                                                0.667
                                            ],
                                            "y": [
                                                0.446
                                            ]
                                        },
                                        "o": {
                                            "x": [
                                                0.333
                                            ],
                                            "y": [
                                                0
                                            ]
                                        },
                                        "n": [
                                            "0p667_0p446_0p333_0"
                                        ],
                                        "t": 0,
                                        "s": [
                                            98
                                        ],
                                        "e": [
                                            79.685
                                        ]
                                    },
                                    {
                                        "i": {
                                            "x": [
                                                0.667
                                            ],
                                            "y": [
                                                0.824
                                            ]
                                        },
                                        "o": {
                                            "x": [
                                                0.333
                                            ],
                                            "y": [
                                                0.331
                                            ]
                                        },
                                        "n": [
                                            "0p667_0p824_0p333_0p331"
                                        ],
                                        "t": 11,
                                        "s": [
                                            79.685
                                        ],
                                        "e": [
                                            63
                                        ]
                                    },
                                    {
                                        "i": {
                                            "x": [
                                                0.667
                                            ],
                                            "y": [
                                                0.769
                                            ]
                                        },
                                        "o": {
                                            "x": [
                                                0.333
                                            ],
                                            "y": [
                                                0.114
                                            ]
                                        },
                                        "n": [
                                            "0p667_0p769_0p333_0p114"
                                        ],
                                        "t": 17,
                                        "s": [
                                            63
                                        ],
                                        "e": [
                                            58.713
                                        ]
                                    },
                                    {
                                        "i": {
                                            "x": [
                                                0.667
                                            ],
                                            "y": [
                                                0.541
                                            ]
                                        },
                                        "o": {
                                            "x": [
                                                0.333
                                            ],
                                            "y": [
                                                0.401
                                            ]
                                        },
                                        "n": [
                                            "0p667_0p541_0p333_0p401"
                                        ],
                                        "t": 18,
                                        "s": [
                                            58.713
                                        ],
                                        "e": [
                                            53.785
                                        ]
                                    },
                                    {
                                        "i": {
                                            "x": [
                                                0.667
                                            ],
                                            "y": [
                                                0.542
                                            ]
                                        },
                                        "o": {
                                            "x": [
                                                0.333
                                            ],
                                            "y": [
                                                0.484
                                            ]
                                        },
                                        "n": [
                                            "0p667_0p542_0p333_0p484"
                                        ],
                                        "t": 20,
                                        "s": [
                                            53.785
                                        ],
                                        "e": [
                                            51.448
                                        ]
                                    },
                                    {
                                        "i": {
                                            "x": [
                                                0.667
                                            ],
                                            "y": [
                                                0.936
                                            ]
                                        },
                                        "o": {
                                            "x": [
                                                0.333
                                            ],
                                            "y": [
                                                0.42
                                            ]
                                        },
                                        "n": [
                                            "0p667_0p936_0p333_0p42"
                                        ],
                                        "t": 21,
                                        "s": [
                                            51.448
                                        ],
                                        "e": [
                                            46.351
                                        ]
                                    },
                                    {
                                        "i": {
                                            "x": [
                                                0.667
                                            ],
                                            "y": [
                                                1
                                            ]
                                        },
                                        "o": {
                                            "x": [
                                                0.333
                                            ],
                                            "y": [
                                                -0.237
                                            ]
                                        },
                                        "n": [
                                            "0p667_1_0p333_-0p237"
                                        ],
                                        "t": 23,
                                        "s": [
                                            46.351
                                        ],
                                        "e": [
                                            58
                                        ]
                                    },
                                    {
                                        "t": 40.0000016292334
                                    }
                                ],
                                "ix": 1
                            },
                            "e": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": {
                                            "x": [
                                                0.667
                                            ],
                                            "y": [
                                                1
                                            ]
                                        },
                                        "o": {
                                            "x": [
                                                0.333
                                            ],
                                            "y": [
                                                0
                                            ]
                                        },
                                        "n": [
                                            "0p667_1_0p333_0"
                                        ],
                                        "t": 17,
                                        "s": [
                                            100
                                        ],
                                        "e": [
                                            44
                                        ]
                                    },
                                    {
                                        "t": 40.0000016292334
                                    }
                                ],
                                "ix": 2
                            },
                            "o": {
                                "a": 0,
                                "k": 0,
                                "ix": 3
                            },
                            "m": 1,
                            "ix": 2,
                            "nm": "Trim Paths 1",
                            "mn": "ADBE Vector Filter - Trim",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [
                                    0.69,
                                    0.655,
                                    0.757,
                                    1
                                ],
                                "ix": 3
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 4
                            },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5
                            },
                            "lc": 2,
                            "lj": 1,
                            "ml": 4,
                            "ml2": {
                                "a": 0,
                                "k": 4,
                                "ix": 8
                            },
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": {
                                "a": 0,
                                "k": [
                                    1,
                                    0,
                                    0,
                                    1
                                ],
                                "ix": 4
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 5
                            },
                            "r": 1,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": true
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Shape 1",
                    "np": 4,
                    "cix": 2,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 150.000006109625,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 3,
            "ty": 4,
            "nm": "Shape Layer 1",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 1,
                    "k": [
                        {
                            "i": {
                                "x": [
                                    0.667
                                ],
                                "y": [
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.333
                                ],
                                "y": [
                                    0
                                ]
                            },
                            "n": [
                                "0p667_1_0p333_0"
                            ],
                            "t": 30,
                            "s": [
                                100
                            ],
                            "e": [
                                1
                            ]
                        },
                        {
                            "t": 36.0000014663101
                        }
                    ],
                    "ix": 11
                },
                "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 10
                },
                "p": {
                    "a": 0,
                    "k": [
                        130,
                        320,
                        0
                    ],
                    "ix": 2
                },
                "a": {
                    "a": 0,
                    "k": [
                        0,
                        0,
                        0
                    ],
                    "ix": 1
                },
                "s": {
                    "a": 0,
                    "k": [
                        100,
                        100,
                        100
                    ],
                    "ix": 6
                }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "o": [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    "v": [
                                        [
                                            -116.872,
                                            -34.976
                                        ],
                                        [
                                            318.199,
                                            -34.976
                                        ]
                                    ],
                                    "c": false
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "tm",
                            "s": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": {
                                            "x": [
                                                0.671
                                            ],
                                            "y": [
                                                20.684
                                            ]
                                        },
                                        "o": {
                                            "x": [
                                                0.333
                                            ],
                                            "y": [
                                                0
                                            ]
                                        },
                                        "n": [
                                            "0p671_20p684_0p333_0"
                                        ],
                                        "t": 0,
                                        "s": [
                                            99
                                        ],
                                        "e": [
                                            100
                                        ]
                                    },
                                    {
                                        "i": {
                                            "x": [
                                                0.814
                                            ],
                                            "y": [
                                                1
                                            ]
                                        },
                                        "o": {
                                            "x": [
                                                0.34
                                            ],
                                            "y": [
                                                0.125
                                            ]
                                        },
                                        "n": [
                                            "0p814_1_0p34_0p125"
                                        ],
                                        "t": 24,
                                        "s": [
                                            100
                                        ],
                                        "e": [
                                            39
                                        ]
                                    },
                                    {
                                        "t": 33.0000013441176
                                    }
                                ],
                                "ix": 1
                            },
                            "e": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": {
                                            "x": [
                                                0.667
                                            ],
                                            "y": [
                                                1
                                            ]
                                        },
                                        "o": {
                                            "x": [
                                                0.333
                                            ],
                                            "y": [
                                                0
                                            ]
                                        },
                                        "n": [
                                            "0p667_1_0p333_0"
                                        ],
                                        "t": 0,
                                        "s": [
                                            100
                                        ],
                                        "e": [
                                            38
                                        ]
                                    },
                                    {
                                        "t": 30.0000012219251
                                    }
                                ],
                                "ix": 2
                            },
                            "o": {
                                "a": 0,
                                "k": 0,
                                "ix": 3
                            },
                            "m": 1,
                            "ix": 2,
                            "nm": "Trim Paths 1",
                            "mn": "ADBE Vector Filter - Trim",
                            "hd": false
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [
                                    0.529,
                                    0.475,
                                    0.631,
                                    1
                                ],
                                "ix": 3
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 4
                            },
                            "w": {
                                "a": 0,
                                "k": 24,
                                "ix": 5
                            },
                            "lc": 2,
                            "lj": 1,
                            "ml": 4,
                            "ml2": {
                                "a": 0,
                                "k": 4,
                                "ix": 8
                            },
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": {
                                "a": 0,
                                "k": [
                                    1,
                                    0,
                                    0,
                                    1
                                ],
                                "ix": 4
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 5
                            },
                            "r": 1,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": true
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    30,
                                    0
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Shape 1",
                    "np": 4,
                    "cix": 2,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 150.000006109625,
            "st": 0,
            "bm": 0
        }
    ],
    "markers": []
}